import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect = () => {
    // on('turbo:load', this.hideUploader)
  }

  disconnect = () => {
    // off('turbo:load', this.hideUploader)
  }

  // hideUploader = () => {
  //   const uploader = document.getElementById('uploads-toggle')
  //   if (!uploader) return

  //   if (this.canUpload) {
  //     this.hideDropOver(false)
  //   }
  //   else {
  //     this.uploadsPanel.classList.add('hidden')
  //     uploader.classList.add('hidden')

  //     this.hideDropOver()
  //   }
  // }

  hideDropOver = (hide = true) => {
    const dropOver = document.getElementById('dropOver')
    if (!dropOver) {
      return
    }

    if (hide) {
      dropOver.classList.add('opacity-0')
    }
    else {
      dropOver.classList.remove('opacity-0')
    }
  }

  get canUpload() {
    return this.uploadsPanel.dataset.visiblePath === window.location.pathname
  }

  // get uploadsPanel() {
  //   return document.getElementById('uploads-panel')
  // }
}
